import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { format } from 'date-fns';
import { fi } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';

const formatDate = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  return format(d, 'dd.MM.yyyy HH:mm', { locale: fi });
};

const ConversationCard = ({ conversation }) => {
  const navigate = useNavigate();
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'active':
        return 'warning';
      default:
        return 'default';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'Valmis';
      case 'active':
        return 'Aktiivinen';
      default:
        return 'Tuntematon';
    }
  };

  const handleClick = () => {
    navigate(`/app/conversations/${conversation._id || conversation.id}`);
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        mb: 2,
        cursor: 'pointer',
        minHeight: 180,
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: (theme) => theme.shadows[4],
          backgroundColor: (theme) => theme.palette.action.hover,
        },
        transition: 'all 0.2s ease-in-out',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Keskustelu {conversation._id?.slice(-6) || conversation.id?.slice(-6) || ''}
            </Typography>
            <Box display="flex" gap={1} alignItems="center">
              <Chip
                label={getStatusText(conversation.status)}
                size="small"
                color={getStatusColor(conversation.status)}
                variant="outlined"
              />
              <Chip
                label={`${conversation.messages?.length || 0} viestiä`}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Box>
          </Box>
        </Box>
        <Box mb={1}>
          <Typography variant="body2" color="text.secondary">
            Käyttäjä: {conversation.userId?.name || conversation.userId?.email || conversation.userId || 'Tuntematon'}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={2} mt="auto">
          <Typography variant="body2" color="text.secondary">
            Luotu: {formatDate(conversation.createdAt)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Päivitetty: {formatDate(conversation.updatedAt)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ConversationCard; 